import { component } from 'picoapp'
import { zelektor } from '@/lib/utility-functions.js'

export default component(node => {
	/*******************************************************************************************************************************************/
	/* Data + Elements
	/*******************************************************************************************************************************************/
	const { countrySelect, provinceSelect, provinceWrapper } = zelektor(node)
	const countryDefault = countrySelect.getAttribute('data-default') ? countrySelect.getAttribute('data-default') : countrySelect.options[0].innerText
	const provinceDefault = provinceSelect.getAttribute('data-default')


	/*******************************************************************************************************************************************/
	/* Initialize
	/*******************************************************************************************************************************************/
	selectDefaults()
	check()


	/*******************************************************************************************************************************************/
	/* Event Listeners
	/*******************************************************************************************************************************************/
	countrySelect.addEventListener('change', check)


	/*******************************************************************************************************************************************/
	/* Functions
	/*******************************************************************************************************************************************/	
	function selectOption(value, select){
		return Array.prototype.slice.call(select.options).filter(function(option, i) {
			if (option.innerText === value){
				select.selectedIndex = i
				return true
			}
			return false
		})[0]
	}

	function showProvinces(options) {
		const previousValue = provinceSelect.options[0] ? provinceSelect.options[0].value : false
		const isNewValue = !previousValue || options[0][0] !== previousValue ? true : false

		if (isNewValue) {
			// Emptry provinces select
			provinceSelect.innerHTML = ''

			// Generate new options from values
			for (var i = 0; i < options.length; i++) {
				var option = document.createElement('option')
				option.value = options[i][0]
				option.innerHTML = options[i][1]
				provinceSelect.appendChild(option)
			}
		}

		// Select the default province
		if (provinceDefault.length > 0) selectOption(provinceDefault, provinceSelect)

		// Show provinces
		provinceWrapper.style.display = ''
	}

	function hideProvinces() {
			provinceWrapper.style.display = 'none'
	}

	function selectDefaults() {
		if (countryDefault.length < 1) return
		const selectedCountry = selectOption(countryDefault, countrySelect)
		const options = JSON.parse(selectedCountry.getAttribute('data-provinces'))

		showProvinces(options)
	}

	function check() {
			const selectedCountry = countrySelect.options[countrySelect.selectedIndex]
			const options = JSON.parse(selectedCountry.getAttribute('data-provinces')) || []
			options.length > 0 ? showProvinces(options) : hideProvinces()
	}
})